"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropSearchSuggestionTypeEnum = exports.PropSearchQueryTypeEnum = void 0;
exports.PropSearchQueryTypeEnum = {
    ManualSearch: 'Manual Search',
    Suggestions: 'Suggestions',
};
exports.PropSearchSuggestionTypeEnum = {
    Dynamic: 'dynamic',
    Trending: 'trending',
    Topics: 'topics',
    Recent: 'recent',
};
//# sourceMappingURL=prop-search.js.map